import { render, staticRenderFns } from "./TwCommunication.vue?vue&type=template&id=19df025c&scoped=true&"
import script from "./TwCommunication.vue?vue&type=script&lang=js&"
export * from "./TwCommunication.vue?vue&type=script&lang=js&"
import style0 from "./TwCommunication.vue?vue&type=style&index=0&id=19df025c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19df025c",
  null
  
)

export default component.exports